<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="title">MARTIN GILBERT <br/>IN ISHMAEL’S HOUSE</h1>
<p class="subtitle">A HISTORY OF JEWS IN MUSLIM LANDS</p>
<p class="logo">YALE UNIVERSITY PRESS<br/>NEW HAVEN AND LONDON</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1d2a7723